import { render, staticRenderFns } from "./ServicePackage.vue?vue&type=template&id=3804761a&scoped=true&"
import script from "./ServicePackage.vue?vue&type=script&lang=js&"
export * from "./ServicePackage.vue?vue&type=script&lang=js&"
import style0 from "./ServicePackage.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ServicePackage.vue?vue&type=style&index=1&id=3804761a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3804761a",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VBtn,VIcon,VMenu,VSwitch})


/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3289102252/src/struxture-clientportal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3804761a')) {
      api.createRecord('3804761a', component.options)
    } else {
      api.reload('3804761a', component.options)
    }
    module.hot.accept("./ServicePackage.vue?vue&type=template&id=3804761a&scoped=true&", function () {
      api.rerender('3804761a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/agreements/schema/ServicePackage.vue"
export default component.exports